<template>
  <div class="cg-month-grid">
    <div
      v-for="m in months"
      :key="m.m"
      class="card cg-month-card cg-clickable"
      :class="{ 'cg-month-card--selected': selected === m.m }"
      title="Show this portfolio's certificates in the table below"
      role="button"
      tabindex="0"
      :aria-pressed="selected === m.m"
      :aria-label="`${m.period}: ${m.statusLabel}. Select to filter certificates`"
      @click="$emit('select', m.m)"
      @keydown.enter.prevent="$emit('select', m.m)"
      @keydown.space.prevent="$emit('select', m.m)"
    >
      <div class="card-body p-3">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <span class="fw-semibold">{{ m.label }}</span>
          <span class="d-flex align-items-center gap-2">
            <ToneBadge :tone="m.basisTone" :label="m.basis" />
            <button
              type="button"
              class="btn btn-sm btn-link p-0 text-body-secondary"
              title="Open portfolio detail"
              aria-label="Open portfolio detail"
              @click.stop="$emit('open', m.m)"
              @keydown.stop
            >
              <font-awesome-icon icon="expand-arrows-alt" />
            </button>
          </span>
        </div>
        <StatBlock :value="fmt(m.consumption)" unit="MWh" class="mb-2" />
        <StackedBar :segments="m.segments" :height="6" class="rounded-pill" />
        <p
          class="mb-0 mt-2 small"
          :class="
            m.statusWarn ? 'text-warning-emphasis' : 'text-body-secondary'
          "
        >
          {{ m.statusLabel }}
        </p>
        <p v-if="!m.hasLots" class="mb-0 mt-1 text-body-secondary small">
          No certificates yet
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FranceMonthCard } from "@/compliance_groups/fixture/derive";
import { fmt } from "@/compliance_groups/fixture/format";
import StackedBar from "./StackedBar.vue";
import StatBlock from "./StatBlock.vue";
import ToneBadge from "./ToneBadge.vue";

defineProps<{ months: FranceMonthCard[]; selected: number | null }>();
defineEmits<{ select: [monthIndex: number]; open: [monthIndex: number] }>();
</script>

<style scoped lang="scss">
.cg-month-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(158px, 1fr));
  gap: 10px;
}
</style>
